import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuilding = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M23.25 19.5h-1.5V9a.75.75 0 1 0 0-1.5h-4.5v-3a.75.75 0 1 0 0-1.5H3.75a.75.75 0 0 0 0 1.5v15h-1.5a.75.75 0 1 0 0 1.5h21a.75.75 0 1 0 0-1.5m-3-10.5v10.5h-3V9zm-15-4.5h10.5v15H13.5V15a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75v4.5H5.25zm6.75 15H9v-3.75h3zm-5.25-12a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 1-.75-.75m4.5 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 1 1 0 1.5H12a.75.75 0 0 1-.75-.75m-4.5 3.75a.75.75 0 0 1 .75-.75H9A.75.75 0 1 1 9 12H7.5a.75.75 0 0 1-.75-.75m4.5 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 1 1 0 1.5H12a.75.75 0 0 1-.75-.75"
	})
});
export default SvgBuilding;
